<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="isNewEventType">NEW EVENT</span>
        <span *ngIf="!isNewEventType && (eventType.id === null)">LOADING EVENT...</span>
        <span *ngIf="!isNewEventType && (eventType.id !== null)">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <nav class="navbar navbar-expand navbar-light bg-light event-create-edit-nav pl-2" *ngIf="isNewEventType">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a routerLink="/events/setup/add" class="nav-link active" href="#">Event Details</a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Pricing</a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type === ScheduleType.rolling)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Membership</a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type === ScheduleType.rolling)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">
            Rosters
          </a>
        </li>
        <li class="nav-item">
          <a routerLink="/nolink" class="nav-link disabled" href="#">
            {{ (!loadingEventType && eventType) ? ((eventType.schedule_type === ScheduleType.oneOff) ? 'Occurrences' : 'Schedules') : 'Loading..' }}
          </a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.oneOff)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">
            Schedule Exceptions
          </a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Questions</a>
        </li>
        <li class="nav-item">
          <a routerLink="/nolink" class="nav-link disabled" href="#">
            Columns
          </a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Emails</a>
        </li>
        <li class="nav-item"
            *ngIf="!loadingEventType && eventType && (eventType.schedule_type !== ScheduleType.rolling)">
          <a routerLink="/nolink" class="nav-link disabled" href="#">Cancellation Policy</a>
        </li>
        <li class="nav-item">
          <a routerLink="/nolink" class="nav-link disabled" href="#">
            Waitlist
          </a>
        </li>
      </ul>
    </nav>
    <app-event-setup-nav *ngIf="!isNewEventType"
                         [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <form (submit)="onEventTypeSubmit()" class="m-4">

      <div class="alert alert-info" role="alert" *ngIf="loadingEventType">
        Loading...
      </div>

      <ng-container *ngIf="!loadingEventType">

        <div class="row">
          <div class="col-md-8 col-xl-6">

            <div class="form-group">
              <label for="nameInput">Event Name *</label>
              <input id="nameInput" type="text" class="form-control" name="name"
                     [(ngModel)]="eventType.name"
                     (ngModelChange)="unsavedChanges = true">
              <div class="form-text text-danger">{{ eventTypeErrors.name }}</div>
            </div>

            <div class="form-group"
                 [ngbTooltip]="isNewEventType ? null : 'May not be changed for an existing event type.'">
              <label for="isRepeatingSelect">Schedule Type *</label>
              <select id="isRepeatingSelect" class="custom-select" name="schedule_type"
                      [(ngModel)]="eventType.schedule_type"
                      (ngModelChange)="unsavedChanges = true"
                      [disabled]="!isNewEventType">
                <option [ngValue]="ScheduleType.repeating">Repeating</option>
                <option [ngValue]="ScheduleType.oneOff">Multi-part/One-off</option>
                <option [ngValue]="ScheduleType.rolling">Rolling</option>
              </select>
              <small class="form-text text-muted">
                A repeating event will appear on the calendar according to one or more weekly schedules, until it is retired or the schedules reach a set end date. It is best used for regular sessions which are booked individually (e.g., yoga classes and pre-booked bouldering sessions).
                <br><br>
                A multi-part/one-off event, however, is scheduled individually. It is best used for special events or courses which meet multiple times (e.g., competitions and youth programming).
                <br><br>
                A rolling event is scheduled like a repeating event, however the participants are grouped into rosters and billed on a repeating basis.
              </small>
              <div class="form-text text-danger">{{ eventTypeErrors.schedule_type }}</div>
            </div>

            <div class="form-group" *ngIf="eventType.schedule_type === ScheduleType.repeating">
              <label for="is_private_event_request_form">
                Is this repeating event used as a Private Event request form?
              </label>
              <select id="is_private_event_request_form"
                      name="is_private_event_request_form"
                      class="custom-select"
                      [(ngModel)]="eventType.is_private_event_request_form"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="false">No</option>
                <option [ngValue]="true">Yes</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.is_private_event_request_form }}</div>
              <small class="form-text text-muted">
                When a repeating event is used as a private event request form, a button is added to each scheduled event allowing staff to quickly create a private event at the booked time. Any payment collected for the request form will automatically be applied to the private event.
                <br><br>
                When making private event request booking, the customer does not need to provide the details for each participant, as they may be added later.
              </small>
              <div class="alert alert-info mt-2" *ngIf="eventType.is_private_event_request_form">
                We recommend using the "Maximum Number of Bookings per Event" setting in order to limit the number of private events which may be requested for each time slot.
              </div>
            </div>

            <ng-container *ngIf="isNewEventType">
              <div class="form-group">
                <label for="statusSelect">Status *</label>
                <select id="statusSelect" class="custom-select" name="status"
                        [(ngModel)]="eventType.status"
                        (ngModelChange)="unsavedChanges = true">
                  <option value="{{ EventTypeStatus.draft }}">Draft</option>
                  <option value="{{ EventTypeStatus.active }}">Active</option>
                  <option value="{{ EventTypeStatus.retired }}">Retired</option>
                </select>
                <div class="form-text text-danger">{{ eventTypeErrors.status }}</div>
              </div>
            </ng-container>

            <div class="form-group">
              <label for="has_limited_location_availability">
                Is this event type only offered at specific locations?
              </label>
              <select id="has_limited_location_availability"
                      name="has_limited_location_availability"
                      class="custom-select"
                      [(ngModel)]="eventType.has_limited_location_availability"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="false">No</option>
                <option [ngValue]="true">Yes</option>
              </select>
              <small class="form-text text-muted">
                If "Yes", only the selected locations will appear as options when configuring events of this type, and in the Climber App calendar, this event type will only shown as a filter option at the selected locations. Existing events will not be impacted.
              </small>
            </div>

            <div class="form-group indented-subsection"
                 *ngIf="eventType.has_limited_location_availability">
              <app-id-list-selector [idList]="eventType.allowed_location_ids"
                                    [(unsavedChanges)]="unsavedChanges"
                                    [options]="locationList"
                                    [title]="'At which locations is this event type offered?'"
                                    [optionsEmptyMessage]="'No locations available.'"></app-id-list-selector>
            </div>

            <div class="form-group">
              <label>Event Description Text</label>
              <app-markdown-editor [(content)]="eventType.description_text"
                                   (contentChange)="unsavedChanges = true"
                                   [id]="'descriptionText'">
              </app-markdown-editor>
              <small class="form-text text-muted">
                This is displayed when a customer begins the process of booking this event by selecting it from the "Select Event" list in the Climber App.
              </small>
              <div class="form-text text-danger">{{ eventTypeErrors.description_text }}</div>
            </div>

            <div class="form-group">
              <label>Area capacity policy</label>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="reserves_area_capacity"
                       id="reserves_area_capacity_true"
                       [(ngModel)]="eventType.reserves_area_capacity"
                       (ngModelChange)="unsavedChanges = true"
                       [value]="true">
                <label class="form-check-label" for="reserves_area_capacity_true">
                  This area can be used for another event at the same time, but <b style="color:black">this event holds spots regardless of actual registration numbers</b>, impacting other events' capacities (ie, a 6 person 'Intro To Bouldering' class conducted in a general climbing area holds 6 spots, even if only 4 people have signed up).
                </label>
              </div>
              <div class="form-check mt-2">
                <input class="form-check-input" type="radio" name="reserves_area_capacity"
                       id="reserves_area_capacity_false"
                       [(ngModel)]="eventType.reserves_area_capacity"
                       (ngModelChange)="unsavedChanges = true"
                       [value]="false">
                <label class="form-check-label" for="reserves_area_capacity_false">
                  This event will use any capacity not used or reserved for other events (ie, general climbing sessions).
                </label>
              </div>
              <small class="form-text text-muted">
                This policy only applies to events which are assigned to an Area (set on the event's schedule). Events with no Area are limited by their own capacity alone.
              </small>
            </div>

            <div class="form-group">
              <label for="lateBookingWindowInput">Late Booking Window (minutes) *</label>
              <input id="lateBookingWindowInput" type="number" class="form-control"
                     name="lateBookingWindow" required max="1440" step="1"
                     [(ngModel)]="eventType.late_booking_window_minutes"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                The number of minutes after an event's start that a reservation may be made for the event. Setting this to a positive value allows users to make bookings after the event has begun. Alternatively, this may be set to a negative value in order to prevent users from booking too close to the start of an event.
              </small>
              <div class="form-text text-danger">
                {{ eventTypeErrors.late_booking_window_minutes }}
              </div>
            </div>

            <div class="form-group">
              <label for="isListedSelect">Visibility *</label>
              <select id="isListedSelect" class="custom-select" name="isListed"
                      [(ngModel)]="eventType.is_listed"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Listed</option>
                <option [ngValue]="false">Unlisted</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.is_listed }}</div>
              <small class="form-text text-muted">
                Whether the event is listed in your location's scheduler homepage. Unlisted events can still be accessed directly via their URL, but they are not visible in the homepage.
              </small>
            </div>

            <div class="form-group">
              <label for="displayPricingInClimberAppListingsSelect">Show event pricing in Climber App listings *</label>
              <select id="displayPricingInClimberAppListingsSelect" class="custom-select"
                      name="displayPricingInClimberAppListings"
                      [(ngModel)]="eventType.display_pricing_in_climber_app_listings"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.display_pricing_in_climber_app_listings }}</div>
              <small class="form-text text-muted">
                If "Yes", per-booking and per-participant fees (and deposit, if any) are shown on the Climber App next to events of this type, in both the calendar view and the event type details page.
              </small>
            </div>

            <div class="form-group">
              <label for="displayRemainingCapacityInClimberAppListingsSelect">Show remaining capacity in Climber App listings</label>
              <select id="displayRemainingCapacityInClimberAppListingsSelect" class="custom-select"
                      name="displayRemainingCapacityInClimberAppListings"
                      [(ngModel)]="eventType.display_remaining_capacity_in_climber_app_listings"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="null">Use organization setting<ng-container *ngIf="orgConfig.getOrganizationConfig()">{{ orgConfig.getOrganizationConfig().display_remaining_capacity_in_climber_app_listings ? ' (Yes)' : ' (No)' }}</ng-container></option>
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.display_remaining_capacity_in_climber_app_listings }}</div>
              <small class="form-text text-muted">
                Whether the number of open spots is shown next to events of this type on the Climber App schedule. "Use organization setting" follows the organization-wide setting under <a routerLink="/organization-settings" fragment="climber-app-settings" target="_blank">Organization Settings</a>. Customers still see whether an event is bookable, waitlist-only, or fully booked.
              </small>
            </div>

            <div class="form-group">
              <label for="hasAutomaticCheckInSelect">Automatic Check-In *</label>
              <select id="hasAutomaticCheckInSelect" class="custom-select" name="hasAutomaticCheckIn"
                      [(ngModel)]="eventType.has_automatic_check_in"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">On</option>
                <option [ngValue]="false">Off</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.has_automatic_check_in }}</div>
              <small class="form-text text-muted">
                If this is on, a customer will be automatically checked in to this event when they check in to the facility, provided they check in between 15 minutes before the start of the event, and the end of the event.
              </small>
            </div>

            <div class="form-group"
                 *ngIf="eventType.schedule_type !== ScheduleType.rolling">
              <label for="maxDailyReservationsInput">Maximum Daily Reservations per Customer</label>
              <input id="maxDailyReservationsInput" type="number" class="form-control"
                     name="max_reservations_per_day_for_customer" min="1" step="1"
                     [(ngModel)]="eventType.max_reservations_per_day_for_customer"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                The maximum number of reservations of this event that may be made for a single customer in a single day. Note that the number of bookings is not limited by this option, only the number of individual reservations for each customer. If this is left blank, no limit will be enforced.
              </small>
              <div class="form-text text-danger">
                {{ eventTypeErrors.max_reservations_per_day_for_customer }}
              </div>
            </div>

            <div class="form-group"
                 *ngIf="eventType.schedule_type !== ScheduleType.rolling">
              <label for="maxParticipantCountInput">Maximum Number of Participants per Booking</label>
              <input id="maxParticipantCountInput" type="number" class="form-control"
                     name="max_participant_count" min="1" max="100" step="1"
                     [(ngModel)]="eventType.max_participant_count"
                     (ngModelChange)="unsavedChanges = true">
              <div class="form-text text-danger">
                {{ eventTypeErrors.max_participant_count }}
              </div>
            </div>

            <div class="form-group"
                 *ngIf="eventType.schedule_type !== ScheduleType.rolling">
              <label for="maxBookingsPerEventInput">Maximum Number of Bookings per Event</label>
              <input id="maxBookingsPerEventInput" type="number" class="form-control"
                     name="max_bookings_per_event" min="1" max="100" step="1"
                     [(ngModel)]="eventType.max_bookings_per_event"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                This limits the number of bookings which may be made for an individual event of this type. A booking may include anywhere from 1 to {{ eventType.max_participant_count }} individual reservations, per the configured "Maximum Number of Participants per Booking" setting. If this is left blank, no limit will be enforced. Note that this limit applies in addition to the event’s capacity limit – the event will be considered full when one of the two limits is reached.
              </small>
              <div class="form-text text-danger">
                {{ eventTypeErrors.max_bookings_per_event }}
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label for="minParticipantAgeInput">Minimum Participant Age</label>
                  <input id="minParticipantAgeInput" type="number" class="form-control"
                         name="min_participant_age" min="1" step="1"
                         [(ngModel)]="eventType.min_participant_age"
                         (ngModelChange)="unsavedChanges = true">
                  <div class="form-text text-danger">
                    {{ eventTypeErrors.min_participant_age }}
                  </div>
                </div>
                <div class="col">
                  <label for="maxParticipantAgeInput">Maximum Participant Age</label>
                  <input id="maxParticipantAgeInput" type="number" class="form-control"
                         name="max_participant_age" min="1" step="1"
                         [(ngModel)]="eventType.max_participant_age"
                         (ngModelChange)="unsavedChanges = true">
                  <div class="form-text text-danger">
                    {{ eventTypeErrors.max_participant_age }}
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                Age restrictions are checked against the start of the event, as opposed to the time of registration. For example, if a participant is below the minimum age today, but will meet the minimum age by the time the event begins, then they will be allowed to register. These fields may be left blank.
              </small>
            </div>

            <div class="form-group">
              <label for="calendarColorHexSelect">Calendar Color</label>
              <app-color-picker [id]="'calendarColorHexSelect'"
                                [(content)]="eventType.calendar_color_hex"
                                (contentChange)="unsavedChanges = true"></app-color-picker>
              <small class="form-text text-muted">
                This determines the color of events of this type in the Staff Site calendar view. It does not affect the Climber App.
              </small>
              <div class="form-text text-danger">{{ eventTypeErrors.calendar_color_hex }}</div>
            </div>

            <div class="form-group"
                 *ngIf="eventType.schedule_type !== ScheduleType.rolling">
              <label for="requireLoginForBookingSelect">
                Require Login For Booking *
              </label>
              <select id="requireLoginForBookingSelect" class="custom-select"
                      name="require_login_for_booking"
                      [(ngModel)]="eventType.require_login_for_booking"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.require_login_for_booking }}</div>
              <small class="form-text text-muted">
                If this is set to "No", then customers may book this event without being logged in to the Climber App. They will be asked to enter their name, birthday, and email address instead.
              </small>
            </div>

            <div class="form-group"
                 *ngIf="eventType.schedule_type !== ScheduleType.rolling">
              <label for="taxRateSelect">Default Tax Rate</label>
              <div class="float-right">
                <a href="#"
                   (click)="$event.preventDefault();loadTaxRates();">
                  Refresh Tax Rates
                </a>
                |
                <a routerLink="/tax-rates-config" target="_blank">
                  Configure Tax Rates
                </a>
              </div>
              <select id="taxRateSelectLoading" class="custom-select" name="tax_rate"
                      *ngIf="loadingTaxRates" disabled>
                <option>Loading...</option>
              </select>
              <select id="taxRateSelect" class="custom-select" name="tax_rate"
                      *ngIf="!loadingTaxRates"
                      [(ngModel)]="eventType.tax_rate_id"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="null">None</option>
                <option *ngIf="taxRateRemoved(eventType.tax_rate_id)"
                        [ngValue]="eventType.tax_rate_id">
                  {{ eventType.tax_rate_name }} (Removed)
                </option>
                <option *ngFor="let taxRate of taxRateList"
                        [ngValue]="taxRate.id">
                  {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                </option>
              </select>
              <small class="form-text text-muted">
                This default tax rate can be overridden for individual schedules and occurrences.
                <br>
                If no tax rate is configured, a tax rate of 0% will be used for any bookings with fees.
              </small>
              <div class="form-text text-danger">{{ eventTypeErrors.tax_rate_id }}</div>
            </div>

            <h3 class="mt2 mb-1">Required Documents</h3>

            <div class="form-group">
              <label for="hasRequiredWaivers">
                Require participants have <b>any waiver</b> valid at the location of the event?
              </label>
              <select id="hasRequiredWaivers" class="custom-select"
                      name="hasRequiredWaivers"
                      [(ngModel)]="hasRequiredWaivers"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.required_waiver_documents }}</div>
              <small class="form-text text-muted">
                When enabled, each participant must have a valid waiver before a booking is completed. If a participant does not have an active waiver, they will be prompted to fill out the selected waiver for the event's location.
                <br>
                <span class="text-danger">
                  If no waiver document template is configured for a location, this policy will not be enforced for events at that location.
                </span>
              </small>
            </div>

            <ng-container *ngIf="hasRequiredWaivers">

              <p class="text-muted mb-0" *ngIf="eventType.required_waiver_documents.length === 0">
                No waiver documents configured.
              </p>

              <div class="indented-subsection mb-2"
                   *ngFor="let rwd of eventType.required_waiver_documents; let idx = index;">
                <a [routerLink]="'/document-templates/' + rwd.id.toString()" target="_blank">
                  {{ rwd.name }}
                </a>
                <span *ngIf="rwd.is_removed" class="text-danger ml-1"
                      ngbTooltip="This template has been retired. It will keep being enforced until you replace it with an active template.">
                  (Retired)
                </span>
                <ul class="pl-3 mb-1">
                  <li *ngFor="let loc of rwd.locations">
                    {{ loc.name }}
                  </li>
                </ul>
                <button type="button" class="btn btn-outline-danger btn-sm"
                        (click)="eventType.required_waiver_documents.splice(idx, 1); unsavedChanges = true;">
                  Remove
                </button>
              </div>

              <button type="button" class="btn btn-success mt-2 mb-3" style="border-radius: 10px;"
                    (click)="openAddRequiredWaiverModal()">
                Add Waiver Document
              </button>

            </ng-container>

            <div class="form-group">
              <label for="hasParticipantAgreements">
                Require participants have a <b>specific</b> participant agreement document?
              </label>
              <select id="hasParticipantAgreements" class="custom-select"
                      name="hasParticipantAgreements"
                      [(ngModel)]="hasParticipantAgreements"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
              <div class="form-text text-danger">{{ eventTypeErrors.participant_agreement_documents }}</div>
              <small class="form-text text-muted">
              A participant agreement is a document which must be completed for each participant before a booking is completed. One document template may be selected as the participant agreement for each location.
              </small>
            </div>

            <ng-container *ngIf="hasParticipantAgreements">

              <p class="text-muted mb-0" *ngIf="eventType.participant_agreement_documents.length === 0">
                No participant agreement documents configured.
              </p>

              <div class="indented-subsection mb-2"
                   *ngFor="let pad of eventType.participant_agreement_documents; let idx = index;">
                <a [routerLink]="'/document-templates/' + pad.id.toString()" target="_blank">
                  {{ pad.name }}
                </a>
                <span *ngIf="pad.is_removed" class="text-danger ml-1"
                      ngbTooltip="This template has been retired. It will keep being enforced until you replace it with an active template.">
                  (Retired)
                </span>
                <ul class="pl-3 mb-1">
                  <li *ngFor="let loc of pad.locations">
                    {{ loc.name }}
                  </li>
                </ul>
                <button type="button" class="btn btn-outline-danger btn-sm"
                        (click)="eventType.participant_agreement_documents.splice(idx, 1); unsavedChanges = true;">
                  Remove
                </button>
              </div>

              <button type="button" class="btn btn-success mt-2 mb-3" style="border-radius: 10px;"
                    (click)="openAddParticipantAgreementModal()">
                Add Participant Agreement
              </button>

            </ng-container>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
              <h3 class="mt-2 mb-1">Mailchimp Events</h3>

              <p class="text-muted mb-1">
                To learn more, see our
                <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
                   target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
              </p>

              <p class="text-muted mb-1">
                Capitan does not sync any automatic Mailchimp events specific to events; only the custom events configured below are synced. Automatic check-in events such as <code>checked_in</code> are listed under Location Settings.
              </p>

              <small class="form-text text-muted mb-3">
                Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
              </small>

              <div class="form-group">
                <label for="mailchimpCheckInParticipantEventNameInput">Check-In Event Name - Participant</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpCheckInParticipantEventNameInput"
                           type="text" name="mailchimp_check_in_participant_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="eventType.mailchimp_check_in_participant_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the participant whenever they check into an event of this type.
                </small>
                <div class="form-text text-danger">{{ eventTypeErrors.mailchimp_check_in_participant_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpCheckInBookingCustomerEventNameInput">Check-In Event Name - Booking Customer</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpCheckInBookingCustomerEventNameInput"
                           type="text" name="mailchimp_check_in_booking_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="eventType.mailchimp_check_in_booking_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the booking customer whenever a participant in their booking checks into an event of this type. This can be used to, for example, send an email to the parent of a youth program, since they will have created the booking but will not be a participant.
                </small>
                <div class="form-text text-danger">{{ eventTypeErrors.mailchimp_check_in_booking_customer_event_name }}</div>
              </div>

              <div class="form-group"
                   *ngIf="eventType.schedule_type !== ScheduleType.rolling">
                <label for="mailchimpCompletedParticipantEventNameInput">Completed Event Name - Participant</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpCompletedParticipantEventNameInput"
                           type="text" name="mailchimp_completed_participant_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="eventType.mailchimp_completed_participant_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the participant whenever they check into the last part of an event of this type. Note that this is identical to "Check-In Event Name - Participant" for single-part events.
                </small>
                <div class="form-text text-danger">{{ eventTypeErrors.mailchimp_completed_participant_event_name }}</div>
              </div>

              <div class="form-group"
                   *ngIf="eventType.schedule_type !== ScheduleType.rolling">
                <label for="mailchimpCompletedBookingCustomerEventNameInput">Completed Event Name - Booking Customer</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpCompletedBookingCustomerEventNameInput"
                           type="text" name="mailchimp_completed_booking_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="eventType.mailchimp_completed_booking_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the booking customer whenever a participant in their booking checks into the last part of an event of this type. This can be used to, for example, send an email to the parent of a youth program, since they will have created the booking but will not be a participant. Note that this is identical to "Check-In Event Name - Booking Customer" for single-part events.
                </small>
                <div class="form-text text-danger">{{ eventTypeErrors.mailchimp_completed_booking_customer_event_name }}</div>
              </div>
            </ng-container>

          </div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="eventTypeErrors.non_field_errors">
          {{ eventTypeErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="eventTypeErrorMessage">
          {{ eventTypeErrorMessage }}
        </div>

        <!-- Place save button first so that the enter key press activates it -->
        <div class="mt-3">
          <div class="float-right">
            <!-- Invisible button causes the "enter" keypress to be of submit type continue. -->
            <button type="submit" style="display: none" (click)="submitType=SUBMIT_TYPE_CONTINUE"></button>
            <button type="submit" class="btn btn-primary mr-2"
                    [disabled]="loadingEventType" [class.disabled]="loadingEventType"
                    (click)="submitType=SUBMIT_TYPE_GO_BACK">
              Save and Go Back
            </button>
            <button type="submit" class="btn btn-primary"
                    [disabled]="loadingEventType" [class.disabled]="loadingEventType"
                    (click)="submitType=SUBMIT_TYPE_CONTINUE">
              Save and Continue
            </button>
          </div>
          <button [routerLink]="['/events/setup/event-types']"
                  [queryParams]="{status: eventType.status}"
                  [disabled]="loadingEventType" [class.disabled]="loadingEventType"
                  class="btn btn-secondary">
            {{ isNewEventType ? 'Cancel' : 'Back' }}
          </button>
        </div>

      </ng-container>

    </form>

  </div>

</div>
